import { OPEN_SIDEBAR_NAV, DISMISS_SIDEBAR_NAV } from './actionTypes';

export const openSidebarNav = (dispatch) => {
  dispatch({
    type: OPEN_SIDEBAR_NAV,
  });
};

export const dismissSidebarNav = (dispatch) => {
  dispatch({
    type: DISMISS_SIDEBAR_NAV,
  });
};

export default {
  openSidebarNav,
  dismissSidebarNav,
};
